module.exports = __webpack_public_path__ + "static/img/choose.99566ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/choose.png
// module id = nsNY
// module chunks = 1